const DICTIONARIES = {
  en: {
    actual_overtime_hours: 'Actual Overtime Hours',
    actual_pricing_unit: 'Actual Pricing Unit',
    allocation_status: 'Allocation Status',
    cancel_reason: 'Cancel Reason',
    contract_ksuid: 'Contract ID',
    project_ksuid: 'Project ID',
    replacement_fleet_id: 'Replacement Fleet Id',
    replacement_fleet_plate_number: 'Replacement Fleet Plate Number',
    shipper_ksuid: 'Shipper ID',
    transporter_ksuid: 'Transporter ID',
    transporter_price: 'Transporter Price',
  },
};

export default DICTIONARIES;
